module.exports = __webpack_public_path__ + "static/media/icon_afiliados.e3527870.png";